import { render } from "./RecipeComment.vue?vue&type=template&id=157d9b74&scoped=true"
import script from "./RecipeComment.vue?vue&type=script&lang=js"
export * from "./RecipeComment.vue?vue&type=script&lang=js"

import "./RecipeComment.vue?vue&type=style&index=0&id=157d9b74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157d9b74"]])

export default __exports__